module.exports = __webpack_public_path__ + "img/list-pattern3.0137309.svg";